import type { ModuleManifest } from "./types";

// ThirdParties (tabid: 94) — GDPR Art. 28 sub-processors + NIS2 Art. 21d supply chain
export const suppliersManifest: ModuleManifest = {
  name: "suppliers",
  label: "Fornitore / Terza Parte",
  labelPlural: "Fornitori e Terze Parti",
  coreBOSModule: "ThirdParties",
  wsidPrefix: "94x",
  type: "standard",
  routes: {
    list: "/suppliers",
    show: "/suppliers/show/:id",
    create: "/suppliers/create",
    edit: "/suppliers/edit/:id",
  },
  navigation: {
    icon: "TeamOutlined",
    order: 13,
    group: "Security",
  },
  routing: {
    keywords: ["supplier", "suppliers", "fornitore", "fornitori", "third party", "subprocessor"],
    searchFields: ["thirdpartiesname"],
    defaultSort: { field: "thirdpartiesname", order: "asc" },
  },
  context: { supported: true, entityKey: "suppliers" },
  fields: [
    { name: "thirdpartiesname", label: "Nome Fornitore", type: "string", required: true },
    { name: "activity_type", label: "Tipo Attività", type: "picklist" },
    { name: "relthirdparty_account", label: "Account", type: "reference" },
    { name: "pdc_relation", label: "Relazione PDC", type: "reference" },
    { name: "description", label: "Descrizione", type: "text" },
    { name: "assigned_user_id", label: "Assegnato a", type: "reference" },
  ],
  relationships: [
    { module: "Accounts", field: "relthirdparty_account", label: "Account", icon: "BankOutlined", displayField: "accountname" },
  ],
  requiredFields: ["thirdpartiesname"],
  viewStrategy: "generic",
};
